<template>
	<div class="incenters">

		<div style="">
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="SaleBillExport"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>

		</div>
		<div class="TableWidth" v-if="CusTypeFlog == 0">
			<Commontable :loadingTable="false" @handleSelectionChange="handleSelectionChange" @onRowClick="onRowClick"
				colnum=7 :tableData="tableData" :headerData="headerDataTow" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>
		<div class="TableWidth" v-else>
			<Commontable :loadingTable="false" @handleSelectionChange="handleSelectionChange" @onRowClick="onRowClick"
				colnum=7 :tableData="tableData" :headerData="headerData" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>
	</div>
</template>
<script>
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import Pagination from '../../../../components/pagination.vue'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import fromdata from '../fromData/add'
	import fromdataedit from '../fromData/edit'
	import Dialog from '../../../../components/dialog.vue'
	import Commondown from '../../../../components/common-down.vue'
	import CommonbtnUpLoad from '../../../../components/common-upload.vue'
	import CommonBtngroup from '../../../../components/commongroup.vue'
	import headerData from './fromDataTable/headerData'
	import headerDataDetail from './fromDataTable/headerDataDetail'
	import headerDataDespatchupdate from './fromDataTable/headerDataDespatchupdate'
	import headerDataDespatch from './fromDataTable/headerDataDespatch'
	import headerDataTow from './fromDataTable/headerDataTow'
	import {
		SaleBillInfo,
		SaleBillDetail,
		SaleBillDetailUnique,
		SaleBillImport,
		SaleBillDownloadTemplet,
		SaleBillDelete,
		SaleBillVerify,
		SaleBillUnVerify,
		InventoryClassInfo,
		CustomerList,
		HospitalList,
		InventoryClassList,
		ASNVoucherType,
		CusType,
		SaleBillUploadSalesInvListPic,
		SaleBillUploadInvoicePic,
		despatchList,
		wmsDespatchDetail,
		wmsDespatchDetailUnique,
		DespatchDetailByDPMIDs,
		SaleBillUploadInvoicePicByEdit,
		SaleBillCheckInvoicePicByStandard,
		HelperCheckWay,
		SaleBillCheckInvoiceDetail,
		wmsDespatchList,
		SaleBillAdd,
		SaleBillEdit,
		SaleBillUploadSalesInvListByEdit,
		SaleBillDoInvoiceCheckedChange,
	} from '@/api/home'
	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog,
			Commondown,
			CommonbtnUpLoad,
			CommonBtngroup
		},
		props: {
			tableData: {
				type: Array,
				default: Array
			},
			total: {
				type: Number,
				default: 0
			},
			tableDataMD: {
				type: Array,
				default: Array
			},
		},
		data: function() {
			return {
				dialogVisibles: false,
				dialogVisiblesinvoicephoto: false,
				dialogVisibleshen: false,
				dialogVisibleqshen: false,
				dialogVisibleqdel: false,
				rowboo: false,
				loading: false,
				showorhide: false,
				dialogVisiblesdrjg: false,
				dialogVisibleoutboundorder: false,
				editops: false,
				tableflag: true,
				tableflags: false,
				dialogVisibleoutboundorderedit: false,
				Fourelementsfalg: false,
				savefalg: false,
				OKASCAN: true,
				InvoiceChecked: null,
				addupdateType: 0,
				InvoiceCheckeds: null,
				InvoiceValue: "",
				InvoiceRemark: "",
				getText: "",
				rigthText: "确认",
				dpmid: "",
				pageindex: 1,
				pageSize: 20,
				dpmiDsarr: [],
				tableDatadrjg: [],
				invaddfromdata: [],
				invupdatefromdata: [],
				tableDataDespatchupdate: [],
				headerDataTow: [],
				sbmidarr: [],
				tableDataDespatch: [],
				DesData: [],
				editRowTableData: null,
				sbmid: '',
				imagePath: '',
				availability: 0,
				totals: 0,
				isStandardCheck: 0,
				title: "导入结果",
				state: [{
						title: '明细'
					},
					{
						title: '唯一码'
					}
				],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					revoke: false //弃审
				},
				headerDataUnique: [{
						prop: 'id',
						label: '序号',
						columnwidth: 120
					},
					{
						prop: 'Batch',
						label: '批号',
						columnwidth: 260
					},
					{
						prop: 'InvUniqueCode',
						label: '唯一码',
						columnwidth: 450
					},
					{
						prop: 'Quantity',
						label: '数量',
						columnwidth: 450
					},
				],
				headerDataDespatchupdate: [],
				headerDataDetail: [],
				headerData: [],
				headerDataDespatch: [],
				fromdatalists: [{
					inputdata: '',
					fontSize: '14px',
					color: '#333333',
					placeholder: '颜色说明',
					types: '',
					inputtype: 'selects',
					width: '110px',
				}, ],
				downlist: [{
						title: '未上传发票照片',
						colors: "#C0696B"
					},
					{
						title: '上传发票照片未通过',
						colors: "red"
					},
				],
				AddTableSelectiondetailList: [],
				AddTableSelectiondetailUniqueList: [],
				tableDataDetailUnique: [],
				tableDataDetail: [],
				CusTypeFlog: null,
				onchage: 0,
				InvAddCode: "",
				InvName: "",
				Quantity: "",
				TaxUnitPrice: "",
				options1: [{
					lable: "0",
					value: "驳回"
				}, ],
				options2: [{
					lable: "1",
					value: "通过"
				}]
			}
		},
		created() {

		},
		mounted() {
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
			this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
			this.headerData = JSON.parse(JSON.stringify(headerData))
			this.headerDataDetail = JSON.parse(JSON.stringify(headerDataDetail))
			this.headerDataDespatchupdate = JSON.parse(JSON.stringify(headerDataDespatchupdate))
			this.headerDataDespatch = JSON.parse(JSON.stringify(headerDataDespatch))
			this.headerDataTow = JSON.parse(JSON.stringify(headerDataTow))
			this.QX()
			this.cusType()
		},
		methods: {
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"))
				data.Menus.map((item, index) => {
					if (item.NodeID == 16) {
						this.qus = item.Nodes[0].Nodes
					}
				})
				//console.log(this.qus, "this.qus");
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == 'add') {
							this.qx.add = true
						} else if (item.NodeName == 'edit') {
							this.qx.update = true
						} else if (item.NodeName == 'delete') {
							this.qx.del = true
						} else if (item.NodeName == 'stopif') {
							this.qx.del = true
						} else if (item.NodeName == 'assignment') {
							this.qx.assignment = true
						} else if (item.NodeName == 'enabled') {
							this.qx.enabled = true
						} else if (item.NodeName == 'skip') {
							this.qx.skip = true
						} else if (item.NodeName == 'reset') {
							this.qx.reset = true
						}
					})
				}
			},
			tabClick(index) {
				if (index == 0) {
					this.tableflag = true
					this.tableflags = false
					this.wmsDespatchDetail()
				}
				if (index == 1) {
					this.tableflag = false
					this.tableflags = true
					this.wmsDespatchDetailUnique()
				}
				if (this.onchage != index) {
					this.onchage = index
				}
			},
			// 是否通桥员工
			async cusType() {
				let {
					data,
					code
				} = await CusType({})
				if (code == 0) {
					// this.CusTypeState = data.CusType
					if (data.CusType == "") {
						this.CusTypeFlog = 0
						this.editops = false //测试中
						console.log(this.CusTypeFlog, '5555555555555555');
					} else if (data.CusType == "平台") {
						this.CusTypeFlog = 1
					} else if (data.CusType == "经销商") {
						this.CusTypeFlog = 2
					}
				}
			},
			// 出库单列表
			async despatchList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let {
					data,
					code,
					message
				} = await wmsDespatchList({
					pageSize: this.pageSize,
					pageIndex: this.pageindex,
					referToBill: 1
				})
				if (code == 0) {
					this.totals = data.Count
					this.tableDataDespatch = data.data
				} else {
					this.$message({
						type: "error",
						message: message
					})
				}
				loading.close();
			},
			// 出库明细
			async wmsDespatchDetail() {
				let {
					data,
					code
				} = await wmsDespatchDetail({
					dpmid: this.dpmid
				})
				if (code == 0) {
					this.tableDataDetail = data
				}
			},
			// 出库唯一码
			async wmsDespatchDetailUnique() {
				let {
					data,
					code
				} = await wmsDespatchDetailUnique({
					dpmid: this.dpmid
				})
				if (code == 0) {
					this.tableDataDetailUnique = data
				}
			},
			handleCurrentChanges(pageindex) {
				this.pageindex = pageindex
				this.despatchList()
			},
			handleSizeChanges(paegSzie) {
				this.pageSize = paegSzie
				this.despatchList()
			},
			// 详情
			async SaleBillInfo() {
				let {
					code,
					data

				} = await SaleBillInfo({
					sbmid: this.sbmid
				})
				if (code == 0) {
					this.invupdatefromdata[0].inputdata = data.InvoiceNo
					this.invupdatefromdata[1].inputdata = data.SBDate
					this.invupdatefromdata[2].inputdata = data.CheckWayName
					this.invupdatefromdata[3].inputdata = data.VouCode
					this.invupdatefromdata[4].inputdata = data.VerifyCode
					this.invupdatefromdata[5].inputdata = data.SBCode
					this.invupdatefromdata[6].inputdata = data.Remark
					this.invupdatefromdata[7].inputdata = data.InvoiceAmt
					this.invupdatefromdata[8].inputdata = data.CusName
					this.invupdatefromdata[9].inputdata = data.Hospital
					this.invupdatefromdata[10].inputdata = data.ReturnName
					this.tableDataDespatchupdate = data.DetailList
					this.imagePath = data.InvListImage
				}
			},
			// 下载导入模板
			async SaleBillDownloadTemplet() {
				// 测试
				// this.downURL = "https://bs.oudot.cn/Download/入库单导入模板(一级经销商).xlsx"
				let {
					data,
					code,
					message
				} = await SaleBillDownloadTemplet({})
				if (code == 0) {
					window.location.href = data
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 导入
			async SaleBillImport(file) {
				const loading = this.$loading({
					lock: true,
					text: '正在导入...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formdata = new FormData()
				formdata.append('file', file)
				let {
					data,
					code,
					message
				} = await SaleBillImport(formdata)
				if (code == 0) {
					this.$message({
						type: 'success',
						message: message
					});
					loading.close();
					return
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
					loading.close();
					return
				} else {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = "导入结果"
					this.$message({
						type: 'error',
						message: message
					});
					loading.close();
				}
			},
			// 删除
			async saleBillDelete() {
				let arr = []
				this.sbmidarr.map((item, index) => {
					arr.push(item.SBMID)
				})
				let {
					code,
					message
				} = await SaleBillDelete({
					sbmiDs: arr
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '删除成功'
					});
					this.sbmidarr = []
					this.$parent.saleBillList()
				} else {
					this.title = "删除结果"
					this.dialogVisiblesqsjg = true
					this.tableDataqsjg = data
					this.$message({
						type: 'error',
						message: message
					});
				}
				this.rowboo = false
			},
			// 审核
			async saleBillVerify() {
				let arr = []
				this.sbmidarr.map((item, index) => {
					arr.push(item.SBMID)
				})
				let {
					code,
					message,
					data
				} = await SaleBillVerify({
					sbmiDs: arr
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '审核成功'
					});

					this.sbmidarr = []
					this.$parent.saleBillList()
				} else {
					this.title = "审核结果"
					this.dialogVisiblesqsjg = true
					this.tableDataqsjg = data
					this.$message({
						type: 'error',
						message: message
					});
				}
				this.rowboo = false
			},
			// 弃审
			async saleBillUnVerify() {
				let arr = []
				this.sbmidarr.map((item, index) => {
					arr.push(item.SBMID)
				})
				let {
					code,
					message,
					data
				} = await SaleBillUnVerify({
					sbmiDs: arr
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '弃审成功'
					});
					this.sbmidarr = []
					this.$parent.saleBillList()
				} else {
					this.title = "弃审结果"
					this.dialogVisiblesqsjg = true
					this.tableDataqsjg = data
					this.$message({
						type: 'error',
						message: message
					});
				}
				this.rowboo = false
			},
			// 发票照片上传
			async UploadInvoicePicByEdit(file) {
				const loading = this.$loading({
					lock: true,
					text: '正在上传...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formdata = new FormData()
				formdata.append('file', file)
				let {
					code,
					data,
					message
				} = await SaleBillUploadInvoicePicByEdit(formdata)
				if (code == 0) {
					this.invupdatefromdata[0].inputdata = data.InvoiceNo
					this.invupdatefromdata[1].inputdata = data.SBDate
					this.invupdatefromdata[2].inputdata = data.CheckWay
					this.invupdatefromdata[3].inputdata = data.VerifyCode
					this.invupdatefromdata[4].inputdata = data.SBCode
					this.invupdatefromdata[5].inputdata = data.InvoiceAmt
					this.getText = data.GetText
					this.invupdatefromdata.map((item, index) => {
						if (index == 6) {
							item.disabled = false
						} else {
							item.disabled = true
						}
						this.savefalg = true
					})
					this.$message({
						type: 'success',
						message: message
					});
					loading.close();
					return
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
					loading.close();
					return
				} else if (code == 1) {
					this.savefalg = false
					this.Fourelementsfalg = true
					this.$message({
						type: 'error',
						message: message
					});
					loading.close();
				} else {
					this.$message({
						type: 'error',
						message: message
					});
					loading.close();
				}
			},
			Fourelements() {
				this.saleBillCheckInvoicePicByStandard(this.$refs.outupdate)
			},
			async saleBillCheckInvoicePicByStandard(dataList) {
				//console.log(dataList, 'dataList');
				if (dataList[1].modelvalue == "") {
					this.$message({
						type: 'warning',
						message: "开票日期不能为空"
					});
					return false
				}
				if (dataList[2].modelvalue == "") {
					this.$message({
						type: 'warning',
						message: "发票类型不能为空"
					});
					return false
				}
				let {
					code,
					data,
					message
				} = await SaleBillCheckInvoicePicByStandard({
					invoiceNo: dataList[0].modelvalue,
					sbDate: dataList[1].modelvalue,
					checkWay: dataList[2].modelvalue,
					verifyCode: dataList[4].modelvalue,
					sbCode: dataList[5].modelvalue,
					invoiceAmt: dataList[7].modelvalue,
				})
				if (code == 0) {
					this.isStandardCheck = 1
					this.savefalg = true
					this.$message({
						type: "success",
						message: message
					})
				} else {
					this.$message({
						type: "warning",
						message: message
					})
				}

			},
			// 新增
			async SaleBillAdd() {
				let {
					code,
					data,
					message
				} = await SaleBillAdd({
					sbmid: "",
					sbCode: this.$refs.outupdate[5].modelvalue, //发票代码
					invoiceNo: this.$refs.outupdate[0].modelvalue, //发票号码
					sbDate: this.$refs.outupdate[1].modelvalue, //开票日期
					returnFlag: this.returnFlag, //选择的出库是销售订单传0；选择出库是销售退货单传1
					remark: this.$refs.outupdate[6].modelvalue, //备注
					verifyCode: this.$refs.outupdate[4].modelvalue, //校验码
					checkWay: this.$refs.outupdate[2].modelvalue, //发票类型
					invoiceAmt: this.$refs.outupdate[7].modelvalue, //发票照片上的无税金额
					cusCode: this.DesData.CusCode, //客户
					hospital: this.DesData.Hospital, //医院
					getText: this.getText, //发票照片上传时获取的GetText
					invListPicUrl: this.invListPicUrl, //销货清单文件名（修改状态下，未重新上传，则不传）
					detailList: this.tableDataDespatchupdate, //发票明细
					imageInPut: this.imageInPut, //发票照片内容
					sbpdid: this.sbpdid, //加载时获取照片时拿到的SBPDID（修改时未重新上传照片则不传）
					imagePath: this.imagePath, //发票文件名（修改时未重新上传照片则不传）
					availability: this.availability, //发票内容是否校验通过（0：未通过；1：通过）即④号接口是否返回true
					isStandardCheck: this.isStandardCheck //是否四要素校验（0：未调用四要素接口；1：调用过四要素接口）
				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: message
					})
					this.dialogVisiblesdrjg = false
				} else if (code == 101) {
					this.$message({
						type: "warning",
						message: message
					})
				} else {
					this.$message({
						type: "error",
						message: message
					})
				}
			},
			// 修改
			async SaleBillEdit() {
				let {
					code,
					data,
					message
				} = await SaleBillEdit({
					sbmid: this.sbmid,
					sbCode: this.$refs.outupdate[5].modelvalue, //发票代码
					invoiceNo: this.$refs.outupdate[0].modelvalue, //发票号码
					sbDate: this.$refs.outupdate[1].modelvalue, //开票日期
					returnFlag: this.returnFlag, //选择的出库是销售订单传0；选择出库是销售退货单传1
					remark: this.$refs.outupdate[6].modelvalue, //备注
					verifyCode: this.$refs.outupdate[4].modelvalue, //校验码
					checkWay: this.$refs.outupdate[2].modelvalue, //发票类型
					invoiceAmt: this.$refs.outupdate[7].modelvalue, //发票照片上的无税金额
					cusCode: this.cusCode, //客户
					hospital: this.hospital, //医院
					getText: this.getText, //发票照片上传时获取的GetText
					invListPicUrl: this.invListPicUrl, //销货清单文件名（修改状态下，未重新上传，则不传）
					detailList: this.tableDataDespatchupdate, //发票明细
					imageInPut: this.imageInPut, //发票照片内容
					sbpdid: this.sbpdid, //加载时获取照片时拿到的SBPDID（修改时未重新上传照片则不传）
					imagePath: this.imagePath, //发票文件名（修改时未重新上传照片则不传）
					availability: this.availability, //发票内容是否校验通过（0：未通过；1：通过）即④号接口是否返回true
					isStandardCheck: this.isStandardCheck //是否四要素校验（0：未调用四要素接口；1：调用过四要素接口）
				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: message
					})
					this.dialogVisiblesdrjg = false
				} else if (code == 101) {
					this.$message({
						type: "warning",
						message: message
					})
				} else {
					this.$message({
						type: "error",
						message: message
					})
				}
			},
			// 发票内容校验
			async SaleBillCheckInvoiceDetail() {
				let arr = []
				this.tableDataDespatchupdate.map((item, index) => {
					let obj = {
						invAddCode: item.InvAddCode,
						invName: item.InvName,
						vouCode: item.VouCode,
						quantity: item.Quantity,
						taxUnitPrice: item.TaxUnitPrice
					}
					arr.push(obj)
				})
				// //console.log(this.addupdateType, "this.addupdateType");
				// debugger;
				let {
					code,
					data,
					message
				} = await SaleBillCheckInvoiceDetail({
					SBMID: this.addupdateType == 1 ? this.sbmid : "",
					getText: this.getText,
					detailList: arr,
				})
				if (code == 999) {
					this.$message({
						type: "warning",
						message: message
					})
					return
				} else if (code = 0) {
					this.availability = 1

				} else if (code = 1) {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = "结果"
					this.rigthText = "保存"
				} else if (code = 2) {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = "结果"
					this.OKASCAN = false
				}
			},
			// 修改->保存
			save() {
				this.SaleBillCheckInvoiceDetail()
			},
			// 修改->删除选中项
			invDel() {
				var set = this.tableDelArr.map(item => item.SBDID)
				var resArr = this.tableDataDespatchupdate.filter(item => !set.includes(item.SBDID))
				this.tableDataDespatchupdate = resArr
			},
			// 明细
			async HelperCheckWay() {
				let {
					code,
					data,
					message
				} = await HelperCheckWay({})
				if (code == 0) {
					this.invupdatefromdata[2].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.invupdatefromdata[2].options.push(obj)
					})
				}
			},
			onRowClickAdd(val) {
				this.editRowTableData = val
				this.dpmid = val.DPMID
				this.wmsDespatchDetail()
				this.wmsDespatchDetailUnique()
			},
			UnImport() {

			},
			dowload() {

			},

			showclick() {
				this.showorhide = true
			},
			hide() {
				this.showorhide = false

			},
			select() {
				// try {
				//   this.fromList.VouCode = this.$refs.outaddinv[0].modelvalue
				//   this.fromList.InvClass = this.$refs.outaddinv[1].modelvalue
				//   this.fromList.DPDate1 = this.$refs.outaddinv[2].startTime
				//   this.fromList.DPDate2 = this.$refs.outaddinv[2].endTime
				//   this.fromList.Status = this.$refs.outaddinv[3].modelvalue
				//   this.fromList.CusName = this.$refs.outaddinv[4].modelvalue
				//   this.fromList.VerifyTime1 = this.$refs.outaddinv[5].startTime
				//   this.fromList.VerifyTime2 = this.$refs.outaddinv[5].endTime
				//   this.fromList.VoucherType = this.$refs.outaddinv[6].modelvalue
				//   this.fromList.InvAddCode = this.$refs.outaddinv[7].modelvalue
				//   this.fromList.InvName = this.$refs.outaddinv[8].modelvalue
				//   this.fromList.Batch = this.$refs.outaddinv[9].modelvalue
				//   this.despatchList()
				// } catch (error) {
				//   this.despatchList()
				// }
			},
			reset() {
				this.$refs.outaddinv.map((item, index) => {
					if (index == 2 || index == 5) {
						item.startTime = ""
						item.endTime = ""
					}

				})
			},
			addclick() {},
			handleSelectionChangeAddDialogFromTable(val) {
				this.AddTableSelectiondetailList = val
				//console.log(val, "add表格");
			},
			handleSelectionChanges() {
				this.AddTableSelectiondetailUniqueList = val
				//console.log(val, "唯一码");
			},
			async DespatchDetailByDPMIDs() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let dpArr = []
				this.dpmiDsarr.map((item, index) => {
					dpArr.push(item.DPMID)
				})
				let {
					code,
					data,
					message
				} = await DespatchDetailByDPMIDs({
					dpmiDs: dpArr,
				})
				if (code == 0) {
					this.invupdatefromdata[3].inputdata = data.VouCodes
					this.invupdatefromdata[10].inputdata = data.ReturnFlag == 0 ? "蓝票" : "红票"
					this.invupdatefromdata[9].inputdata = data.Hospital
					this.invupdatefromdata[8].inputdata = data.CusName
					this.DesData = data
					this.tableDataDespatchupdate = data.data
					this.dialogVisibleoutboundorderedit = true
					this.dialogVisibleoutboundorder = false
					if (this.CusTypeFlog == 1) {
						this.invupdatefromdata[8].inputflag = true
					}
					if (this.CusTypeFlog == 2) {
						this.invupdatefromdata[9].inputflag = true
					}

					loading.close();
				} else if (code == 101) {
					this.$message({
						type: "warning",
						message: message
					})
					loading.close()
					return
				} else {
					loading.close();
				}
			},
			handleSelectionChangeEdit(val) {
				this.tableDelArr = val
				this.dpmiDsarr = val
				let str = ""
				val.map((item, index) => {
					str += item.VouCode + ","
				})
				this.$refs.outadd[10].modelvalue = str
			},
			handleSelectionChangeAdd(val) {
				//console.log(val, 'valadd');
				let arr = val
				this.dpmiDsarr = val
			},
			// 发票导入
			InvoiceImport(file) {
				this.SaleBillImport(file)
			},
			// 下载模板
			InvoiceDowload() {
				this.SaleBillDownloadTemplet()
			},
			// 上传照片(多选)
			async UploadPhotos(file) {
				const loading = this.$loading({
					lock: true,
					text: '正在上传...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formdata = new FormData()
				for (var i = 0; i < file.length; i++) {
					formdata.append("files", file[i]);
				}
				let {
					data,
					code,
					message
				} = await SaleBillUploadInvoicePic(formdata)
				if (code == 0) {
					this.$message({
						type: 'success',
						message: message
					});
					loading.close();
					return
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
					loading.close();
					return
				} else {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = "上传结果"
					this.$message({
						type: 'error',
						message: message
					});
					loading.close();
				}
			},
			// 上传销货清单
			async UploadSaleslist(file) {
				if (this.rowboo == true) {
					let formdata = new FormData()
					formdata.append('file', file)
					const loading = this.$loading({
						lock: true,
						text: '正在上传...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let {
						data,
						code,
						message
					} = await SaleBillUploadSalesInvListPic(formdata, this.sbmid)
					if (code == 0) {
						this.$message({
							type: 'success',
							message: message
						});
						loading.close();
						return
					} else if (code == 101) {
						this.$message({
							type: 'warning',
							message: message
						});
						loading.close();
						return
					} else {
						this.dialogVisiblesdrjg = true
						this.tableDatadrjg = data
						this.title = "导入结果"
						this.$message({
							type: 'error',
							message: message
						});
						loading.close();
					}
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要操作的数据！'
				});
			},
			// 修改上传照片
			async SaleBillUploadSalesInvListByEdit(file) {
				let formdata = new FormData()
				formdata.append('file', file)
				const loading = this.$loading({
					lock: true,
					text: '正在上传...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					data,
					code,
					message
				} = await SaleBillUploadSalesInvListByEdit(formdata, this.sbmid)
				if (code == 0) {
					this.$message({
						type: 'success',
						message: message
					});
					loading.close();
					this.imagePath = data
					return
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
					loading.close();
					return
				} else {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = "导入结果"
					this.$message({
						type: 'error',
						message: message
					});
					loading.close();
				}
			},
			UploadTopEdit(file) {
				this.SaleBillUploadSalesInvListByEdit(file)
			},
			// 添加保存
			addsave() {
				this.DespatchAddOne()
				if (this.CusTypeFlog == 1) {
					//console.log("添加");
					this.DespatchAddOne()
				} else if (this.CusTypeFlog == 2) {
					this.DespatchAddTow()
				}
			},
			// 修改保存
			editsave() {
				if (this.CusTypeFlog == 1) {
					this.DespatchEditOne()
				} else if (this.CusTypeFlog == 2) {
					this.DespatchEditTow()
				}

			},
			// 点击行
			onRowClick(val) {
				this.rowboo = true
				this.sbmid = val.SBMID
				//console.log(val, "val")
				this.$emit("onRowClick", val)
			},
			canceloutboundorderedit() {
				this.dialogVisibleoutboundorderedit = false
			},
			dialogOKcanceloutboundorderedit() {

				this.dialogVisibleoutboundorderedit = false
			},
			invSel() {
				this.DespatchDetailByDPMIDs()
				this.HelperCheckWay()

			},
			/** 
			 * 如果当前登录的是一级经销商
			 * 下拉框就是二级经销商
			 * */

			async CustomerList(query) {
				this.loading = true
				let {
					data,
					code
				} = await CustomerList({
					cusName: query
				})
				if (code == 0) {
					this.invaddfromdata[4].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.CusCode,
							value: item.CompanyName
						}
						this.invaddfromdata[4].options.push(obj)
					})
					this.loading = false
				}
			},
			/**
			 * 如果当前登录的是二级经销商
			 * 下拉框就是医院
			 */
			async HospitalList(query) {
				this.loading = true
				let {
					data,
					code
				} = await HospitalList({
					hpName: query
				})
				if (code == 0) {
					this.invaddfromdata[4].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.HPID,
							value: item.HPName
						}
						this.invaddfromdata[4].options.push(obj)
					})
					this.loading = false
				}
			},
			remoteMethodtows(query) {
				if (this.CusTypeFlog == 1) {
					this.CustomerList(query)
				} else if (this.CusTypeFlog == 2) {
					this.HospitalList(query)
				}
			},
			// 是否唯一码
			async inventoryClassInfo(invClass) {
				let {
					code,
					data
				} = await InventoryClassInfo({
					invClass: invClass
				})
				if (code == 0) {
					if (data.IsBarCodeControl == 1) {
						let arr = [{
								title: '明细'
							},
							{
								title: '唯一码'
							}
						]
						this.state = arr

					} else if (data.IsBarCodeControl == 0) {
						let arr = [{
							title: '明细'
						}]
						this.state = arr
					}
				}
			},
			invClass(e) {
				this.inventoryClassInfo(e.modelvalue)
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({

				})
				if (code == 0) {
					this.invaddfromdata[1].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.invaddfromdata[1].options.push(obj)
					})
				}
			},
			// 单据类型下拉aSNVoucherType
			async aSNVoucherType() {
				let {
					code,
					data
				} = await ASNVoucherType({})
				if (code == 0) {
					this.invaddfromdata[6].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.invaddfromdata[6].options.push(obj)
					})
				}
			},
			// 判断修改是否可用
			async CusType() {
				let {
					data,
					code
				} = await CusType({})
				if (code == 0) {
					// this.CusTypeState = data.CusType
					if (data.CusType == "") {
						this.editops = false //测试中
					} else if (data.CusType == "平台") {
						this.CusTypeFlog = 1
					} else if (data.CusType == "经销商") {
						this.CusTypeFlog = 2
					}
				}
			},
			SaleBillExport() {
				this.$emit("SaleBillExport")
			},
			canceldrjg() {
				this.dialogVisiblesdrjg = false
			},
			dialogOKdrjg() {
				if (this.addupdateType == 2) {
					this.SaleBillAdd()
				} else if (this.addupdateType == 1) {
					this.SaleBillEdit()
				}

			},
			invAdd() {
				this.inventoryClassList()
				// this.aSNVoucherType()
				this.despatchList()
				this.addupdateType = 2
				this.dialogVisibleoutboundorder = true
			},
			canceloutboundorder() {
				this.dialogVisibleoutboundorder = false
			},
			dialogOKcanceloutboundorder() {

			},
			adduser() {
				this.dialogVisibles = true
			},
			cancel() {
				this.dialogVisibles = false
			},
			dialogOK() {
				this.dialogVisibles = false
			},
			async saleBillDoInvoiceCheckedChange() {
				let {
					code,
					data,
					message
				} = await SaleBillDoInvoiceCheckedChange({
					SBMID: this.sbmid,
					Remark: this.InvoiceRemark,
					CheckLabelStatus: this.InvoiceValue == "驳回" ? 0 : 1,
				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: message
					})
					this.dialogVisiblesinvoicephoto = false
					this.rowboo = false
				} else if (code == 101) {
					this.$message({
						type: "warning",
						message: message
					})
				} else {
					this.$message({
						type: "error",
						message: message
					})
				}
			},
			invoicephoto() {
				if (this.rowboo == true) {
					this.dialogVisiblesinvoicephoto = true
					//console.log(this.InvoiceCheckeds, 'InvoiceCheckeds');
					return
				}
				this.$message({
					type: "error",
					message: "请选择要操作的数据！"
				})
			},
			cancelinvoicephoto() {
				this.dialogVisiblesinvoicephoto = false
			},
			dialogOKinvoicephoto() {
				this.saleBillDoInvoiceCheckedChange()

			},
			shen() {
				if (this.sbmidarr.length > 0) {
					this.dialogVisibleshen = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要审核的数据！'
				});

			},
			cancelshen() {
				this.dialogVisibleshen = false
			},
			dialogOKshen() {
				this.saleBillVerify()
				this.dialogVisibleshen = false
			},
			qshen() {
				if (this.sbmidarr.length > 0) {
					this.dialogVisibleqshen = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要弃审的数据！'
				});

			},
			dialogOKqshen() {
				this.saleBillUnVerify()
				this.dialogVisibleqshen = false
			},
			cancelqshen() {
				this.dialogVisibleqshen = false
			},
			del() {
				if (this.sbmidarr.length > 0) {
					this.dialogVisibleqdel = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要删除的数据！'
				});
			},
			update() {
				if (this.rowboo == true) {
					this.SaleBillInfo()
					this.HelperCheckWay()
					this.dialogVisibleoutboundorderedit = true
					this.addupdateType = 1
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要修改的数据！'
				});
			},
			dialogOKdel() {
				this.saleBillDelete()
				this.dialogVisibleqdel = false
			},
			canceldel() {
				this.dialogVisibleq = false
			},
			downs() {

			},
			handleCurrentChange(pageindex) {
				this.$emit('handleCurrentChange', pageindex)
			},
			handleSizeChange(paegSzie) {
				this.$emit('handleSizeChange', paegSzie)
			},
			handleSelectionChange(val) {
				this.sbmidarr = val
				//console.log(val, "多选");
			},
			Quantity522(obj) {
				let num = Number(obj.e.target.value)
				let BillQuantity = this.editRowTableData.BillQuantity
				if (num < 1) {
					this.editRowTableData.Quantity = 1
				}
				if (num >= BillQuantity) {
					this.editRowTableData.Quantity = BillQuantity
				}
			}
		},
		watch: {
			dialogVisibleoutboundorderedit: {
				handler(newVal, oldVal) {
					if (newVal == false) {

					}
				},
				deep: true
			},
			dialogVisibleoutboundorder: {
				handler(newVal, oldVal) {
					if (newVal == false) {
						this.$refs.Table511.$refs.fileTableSelect.clearSelection()
					}
				},
				deep: true
			}
		}
	}
</script>

<style lang="less" scoped>
	.ativte {
		border: 1px solid red;
		color: #e71d43;
		background-color: #fce8ec;
		transition: 0.2s linear;
	}

	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			/*margin-top: 16px;*/
			/*padding-bottom: 16px;*/
		}

		// div {
		//   margin-left: 8px;
		//   margin-right: 8px;
		//   margin-top: 5px;
		//   margin-bottom: 5px;

		// }
		.from {
			width: 100%;
		}

		.signingroles {
			height: 500px;
			width: 100%;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			// border: 1px solid red;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.topstate {
		width: 100px;
		height: 32px;
		font-size: 14px;
		border: 1px solid #e6e6e6;
		line-height: 32px;
		text-align: center;
		cursor: pointer;
		display: inline-block;
		margin-left: 10px;
		margin-bottom: 20px;
	}

	.dwonleft {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		right: 350px;
		top: 322px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
	}

	.dwonleft:hover {
		background-color: #f0f0f0;
	}

	.elselect {
		/deep/.el-input--suffix .el-input__inner {
			padding-right: 30px;
			height: 40px;
			width: 613px;
			border-radius: 2px;
		}
	}
</style>
